import React from 'react';
import type { ReactElement } from 'react';
import { Redirect, Route } from 'react-router-dom';
import redirects from './Redirects';
import { resolveCardDeeplink } from './resolveCardDeeplink';

/**
 * Supports existing native / Money Coach card deeplink shapes on web
 * (STASH2026-13746). Must run before bare `/cards` → `/investments` so `?id=`
 * is not swallowed.
 */
const renderCardDeeplinkRoutes = (): ReactElement[] => [
	<Route
		exact
		path={['/card', '/cards']}
		key="card-query-deeplink"
		render={({ location }) => {
			const target = resolveCardDeeplink(location.pathname, location.search);
			if (target) {
				return <Redirect to={target} />;
			}
			// Bare /card or /cards → investments (preserves unrelated query params)
			return <Redirect to={{ ...location, pathname: '/investments' }} />;
		}}
	/>,
	<Route
		exact
		path="/card/:cardUuid"
		key="card-path-deeplink"
		render={({ match }) => <Redirect to={`/cards/${match.params.cardUuid}`} />}
	/>,
];

export const renderRedirectRoutes = (): ReactElement[] => [
	...renderCardDeeplinkRoutes(),
	...redirects.map(({ from, to }) => (
		<Route
			exact
			path={from}
			key={`${from}-${to}`}
			render={({ location }) => <Redirect to={{ ...location, pathname: to }} />}
		/>
	)),
];
